<fieldset>
  <legend *ngIf="legend" [class.inline-block]="inline">
    {{ legend }}
    <span *ngIf="required"> *</span>
  </legend>

  <ng-content />

  <div *ngFor="let name of names" class="error-label font-body-small">
    <span
      *ngIf="!showOnlyGroupLevelErrors && group.get(name)?.invalid && group.get(name)?.touched"
      class="error-900-text signal-error-notification-border-icon-text"
    >
      {{ [translationPrefix, name, firstErrorKey(name)].join('.') | finLocalization }}
    </span>
  </div>

  <div
    *ngIf="firstErrorKey() && group?.invalid && group?.touched"
    class="error-label font-body-small"
    data-testid="form-group-error-message"
  >
    <div class="error-900-text signal-error-notification-border-icon-text">
      {{ [groupTranslationPrefix || translationPrefix, firstErrorKey()].join('.') | finLocalization }}
    </div>
  </div>
</fieldset>
